import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { Dispatch } from 'models/meta/action';
import { finishWorkflow } from 'store/actions/workflow';

import { PaymentDeclinedDispatchProps } from './PaymentDeclined.types';
import PaymentDeclined from './PaymentDeclined.layout';


const mapDispatchToProps = (dispatch: Dispatch): PaymentDeclinedDispatchProps =>
    ({ dispatchFinishWorkflow: () => dispatch(finishWorkflow()) });


export default connect(null, mapDispatchToProps)(withTranslation('result-screen')(PaymentDeclined));
